function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import sumBy from "lodash/sumBy";
import uniqBy from "lodash/uniqBy";
import flatten from "lodash/flatten";
import uniq from "lodash/uniq";
import { updateContextState, context } from "../../components/wr-context";
import { getCompositeAddonKey } from "../addons/utils";
import { getCartId } from "../../utils/product";
export var resolvePhase = function(phase) {
    var allocatedHours = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, parentRate = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    var ref;
    var remainingHours = Math.round(phase.percentEstimatedHours / 100 * allocatedHours);
    var rate = phase.rate || parentRate;
    var ret = {
        id: phase.id,
        label: phase.label,
        hours: remainingHours,
        percentEstimatedHours: +phase.percentEstimatedHours,
        rate: rate,
        children: (ref = phase.children) === null || ref === void 0 ? void 0 : ref.map(function(v) {
            return resolvePhase(v, remainingHours, rate);
        })
    };
    return ret;
};
var ZERO_RATE = {
    costCents: 0,
    expenseCents: 0
};
export var flattenPhase = function(phase) {
    var ref;
    var phases = (ref = phase.children) === null || ref === void 0 ? void 0 : ref.map(function(v) {
        return [
            v,
            v.children
        ];
    });
    var roles = uniqBy(flatten(phases.map(function(param) {
        var _param = _slicedToArray(param, 2), v = _param[1];
        return v.map(function(v) {
            return v;
        });
    })), "label");
    var data = roles.reduce(function(acc, role, roleIndex) {
        acc[roleIndex] = new Array(phases.length).fill(0);
        phases.forEach(function(param, phaseIndex) {
            var _param = _slicedToArray(param, 2), subPhases = _param[1];
            subPhases.forEach(function(subPhase) {
                if (subPhase.label === role.label) {
                    acc[roleIndex][phaseIndex] = subPhase.hours;
                }
            });
        });
        return acc;
    }, []);
    return {
        phases: phases.map(function(param) {
            var _param = _slicedToArray(param, 1), _$phase = _param[0];
            return _$phase.label;
        }),
        phasesHourPercentages: Object.fromEntries(phases.map(function(param) {
            var _param = _slicedToArray(param, 1), _$phase = _param[0];
            return [
                _$phase.label,
                _$phase.percentEstimatedHours || 0
            ];
        })),
        roles: roles.map(function(role) {
            return {
                label: role.label,
                rate: role.rate || ZERO_RATE,
                hourPercentages: Object.fromEntries(phases.map(function(param) {
                    var _param = _slicedToArray(param, 2), _$phase = _param[0], phaseChildren = _param[1];
                    var ref;
                    return [
                        _$phase.label,
                        ((ref = phaseChildren.find(function(childRole) {
                            return childRole.label === role.label;
                        })) === null || ref === void 0 ? void 0 : ref.percentEstimatedHours) || 0, 
                    ];
                }))
            };
        }),
        data: data
    };
};
export var calculateItemRowCost = function(itemRow, options) {
    var ref;
    var rateOverrideKey = options.rateOverrideKey, _getDiscount = options.getDiscount, getDiscount = _getDiscount === void 0 ? function() {
        return 0;
    } : _getDiscount, _getPrice = options.getPrice, getPrice = _getPrice === void 0 ? function() {
        return 0;
    } : _getPrice;
    var phasesBreakdown = itemRow.phasesBreakdown || ((ref = itemRow.item) === null || ref === void 0 ? void 0 : ref.phasesBreakdown);
    var result;
    if (phasesBreakdown) {
        var roles = phasesBreakdown.roles, _data = phasesBreakdown.data, data = _data === void 0 ? [] : _data;
        var fullCost = 0;
        var fullExpense = 0;
        data.forEach(function(allocations, i) {
            var timeUnit = sumBy(allocations.map(function(alloc) {
                return typeof alloc === "string" ? parseFloat(alloc) : alloc;
            }));
            var ratesObject = roles[i].rate;
            if (rateOverrideKey) {
                var ref;
                ratesObject = ((ref = ratesObject.settings.overrides) === null || ref === void 0 ? void 0 : ref.find(function(ovr) {
                    return ovr.key === rateOverrideKey;
                })) || ratesObject;
            }
            fullCost += ratesObject.costCents * timeUnit;
            fullExpense += ratesObject.expenseCents * timeUnit;
        });
        result = {
            fullCost: fullCost,
            fullExpense: fullExpense,
            discountedCost: 0
        };
    } else {
        result = getPrice(itemRow);
        if (typeof result !== "object") {
            result = {
                fullCost: result,
                fullExpense: result,
                discountedCost: 0
            };
        }
    }
    var discount = getDiscount(itemRow, _objectSpread({}, options, result));
    result.discountedCost = result.fullCost - discount;
    return result;
};
export var calculateItemGroupCost = function(itemGroup, options) {
    return itemGroup.itemRows.reduce(function(memo, itemRow) {
        return sumCosts(memo, calculateItemRowCost(itemRow, options));
    }, {
        fullCost: 0,
        discountedCost: 0,
        fullExpense: 0
    });
};
export var calculatePhaseConfigCosts = function(phaseConfig, options) {
    var root = {
        itemGroups: []
    };
    phaseConfig.itemGroups.forEach(function(ig) {
        var group = {
            itemRows: []
        };
        ig.itemRows.forEach(function(ir) {
            var row = {
                cost: calculateItemRowCost(ir, options)
            };
            group.itemRows.push(row);
        });
        group.cost = sumCosts.apply(void 0, _toConsumableArray(group.itemRows.map(function(ir) {
            return ir.cost;
        })));
        root.itemGroups.push(group);
    });
    root.cost = sumCosts.apply(void 0, _toConsumableArray(root.itemGroups.map(function(ig) {
        return ig.cost;
    })));
    return root;
};
var safeSum = function(a, b) {
    return Number(a || 0) + Number(b || 0);
};
export var sumCosts = function() {
    for(var _len = arguments.length, costs = new Array(_len), _key = 0; _key < _len; _key++){
        costs[_key] = arguments[_key];
    }
    var result = {
        fullCost: 0,
        discountedCost: 0,
        fullExpense: 0
    };
    costs.forEach(function(cost) {
        var keys = [
            "fullCost",
            "discountedCost",
            "fullExpense"
        ];
        keys.forEach(function(k) {
            result[k] = safeSum(result[k], cost[k]);
        });
    });
    return result;
};
export var calculateItemRowHours = function(itemRow) {
    var ref;
    if (!itemRow.phasesBreakdown && "item" in itemRow) {
        var ref1;
        return (itemRow === null || itemRow === void 0 ? void 0 : (ref1 = itemRow.item) === null || ref1 === void 0 ? void 0 : ref1.hours) || 0;
    }
    return sumBy((ref = itemRow.phasesBreakdown) === null || ref === void 0 ? void 0 : ref.data.map(function(cells) {
        return sumBy(cells.map(function(cell) {
            return Number(cell) || 0;
        }));
    }));
};
export var calculateItemGroupHours = function(itemGroup) {
    return sumBy(itemGroup.itemRows.map(function(itemRow) {
        return calculateItemRowHours(itemRow);
    }));
};
export var calcBidMargin = function(detailedCost) {
    return Math.round(100 * (1 - detailedCost.fullExpense / detailedCost.discountedCost));
};
export var addPhaseConfigIfProductHasPhase = function(item) {
    updateContextState(function(state) {
        if (state.phasesConfig && item.phase) {
            var addonParams = [];
            var _addOnItems;
            var allAddonItems = (_addOnItems = state.addOnItems) !== null && _addOnItems !== void 0 ? _addOnItems : [];
            var existingSelectedAddons = state.selectedAddons;
            item.rows.forEach(function(row) {
                var ref, ref1, ref2;
                if (!((ref = row.options) === null || ref === void 0 ? void 0 : ref.usesAddOnItems)) return;
                (ref1 = item.values[row.id]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.forEach) === null || ref2 === void 0 ? void 0 : ref2.call(ref1, function(selection) {
                    var ref;
                    var parsedSelection = JSON.parse(selection);
                    var parsedValue = JSON.parse(parsedSelection.value);
                    (ref = parsedValue.items) === null || ref === void 0 ? void 0 : ref.forEach(function(conf) {
                        if (!conf.requireConfiguration) return;
                        addonParams.push({
                            id: conf.itemId,
                            parentId: item.id,
                            parentCartId: item.cartId,
                            sourceRowId: row.id,
                            sourceOptionId: parsedSelection.id
                        });
                    });
                });
            });
            var existingSelectedAddonsByKey = (existingSelectedAddons || []).reduce(function(memo, addon) {
                var key = getCompositeAddonKey(addon);
                memo[key] = memo[key] || addon;
                return memo;
            }, {});
            var selectedAddons = addonParams.map(function(params) {
                var existingAddon = existingSelectedAddonsByKey[getCompositeAddonKey(params)];
                if (existingAddon) return existingAddon;
                var addon = allAddonItems.find(function(addon) {
                    return addon.id === params.id;
                });
                return _objectSpreadProps(_objectSpread({}, addon, params), {
                    addonId: getCartId()
                });
            });
            var newRows = selectedAddons.map(function(item) {
                var itemRow = {
                    item: item,
                    id: item.addonId
                };
                if (!item.phase) return itemRow;
                var phasesBreakdown = item.phasesBreakdown;
                return _objectSpreadProps(_objectSpread({}, itemRow), {
                    isExpanded: false,
                    allPhases: uniq(phasesBreakdown.phases),
                    allRoles: uniqBy(phasesBreakdown.roles, "label"),
                    phasesBreakdown: phasesBreakdown
                });
            });
            var newItemGroups = _toConsumableArray(state.phasesConfig.itemGroups);
            if (newItemGroups[0]) {
                newItemGroups[0].itemRows = _toConsumableArray(newItemGroups[0].itemRows).concat(_toConsumableArray(newRows));
            } else {
                newItemGroups = [
                    {
                        itemRows: newRows
                    }
                ];
            }
            state.phasesConfig = {
                itemGroups: newItemGroups
            };
        }
    });
};
export var adjustPhasesConfigOnItemChange = function(item) {
    updateContextState(function(state) {
        if (state.phasesConfig && item.phase) {
            var addonParams = [];
            var _addOnItems;
            var allAddonItems = (_addOnItems = state.addOnItems) !== null && _addOnItems !== void 0 ? _addOnItems : [];
            var existingSelectedAddons = state.selectedAddons;
            state.cart.forEach(function(item) {
                item.rows.forEach(function(row) {
                    var ref, ref1, ref2;
                    if (!((ref = row.options) === null || ref === void 0 ? void 0 : ref.usesAddOnItems)) return;
                    (ref1 = item.values[row.id]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.forEach) === null || ref2 === void 0 ? void 0 : ref2.call(ref1, function(selection) {
                        var ref;
                        var parsedSelection = JSON.parse(selection);
                        var parsedValue = JSON.parse(parsedSelection.value);
                        (ref = parsedValue.items) === null || ref === void 0 ? void 0 : ref.forEach(function(conf) {
                            if (!conf.requireConfiguration) return;
                            addonParams.push({
                                id: conf.itemId,
                                parentId: item.id,
                                parentCartId: item.cartId,
                                sourceRowId: row.id,
                                sourceOptionId: parsedSelection.id
                            });
                        });
                    });
                });
            });
            var existingSelectedAddonsByKey = (existingSelectedAddons || []).reduce(function(memo, addon) {
                var key = getCompositeAddonKey(addon);
                memo[key] = memo[key] || addon;
                return memo;
            }, {});
            var selectedAddons = addonParams.map(function(params) {
                var existingAddon = existingSelectedAddonsByKey[getCompositeAddonKey(params)];
                if (existingAddon) return existingAddon;
                var addon = allAddonItems.find(function(addon) {
                    return addon.id === params.id;
                });
                return _objectSpreadProps(_objectSpread({}, addon, params), {
                    addonId: getCartId()
                });
            });
            var newRows = selectedAddons.map(function(item) {
                var itemRow = {
                    item: item,
                    id: item.addonId
                };
                if (!item.phase) return itemRow;
                var phasesBreakdown = item.phasesBreakdown;
                return _objectSpreadProps(_objectSpread({}, itemRow), {
                    isExpanded: false,
                    allPhases: uniq(phasesBreakdown.phases),
                    allRoles: uniqBy(phasesBreakdown.roles, "label"),
                    phasesBreakdown: phasesBreakdown
                });
            });
            var willAddrows = [];
            newRows.forEach(function(row) {
                var shouldAddRow = state.phasesConfig.itemGroups.every(function(group) {
                    return group.itemRows.every(function(existingRow) {
                        return row.id !== existingRow.id;
                    });
                });
                if (shouldAddRow) {
                    willAddrows.push(row);
                }
            });
            var newGroups = state.phasesConfig.itemGroups.map(function(group) {
                var copyGroup = _objectSpread({}, group);
                copyGroup.itemRows = copyGroup.itemRows.filter(function(row) {
                    return newRows.some(function(newRow) {
                        return newRow.id === row.id;
                    });
                });
                return copyGroup;
            });
            if (newGroups[0]) {
                newGroups[0].itemRows = _toConsumableArray(newGroups[0].itemRows).concat(_toConsumableArray(willAddrows));
            } else {
                newGroups = [
                    {
                        itemRows: willAddrows
                    }
                ];
            }
            state.phasesConfig = {
                itemGroups: newGroups
            };
        }
    });
};
export var isServiceLevelDiscountingEnabled = function() {
    var ref;
    return (ref = context.state.companySettings) === null || ref === void 0 ? void 0 : ref.isServiceLevelDiscountingEnabled;
};
